<template>
  <div class="table">
    <slot />

    <Pagination
      :params="params"
      :total="total"
      @current-change="onCurrentChange"
      @size-change="onSizeChange"
    />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination';

export default {
  components: {
    Pagination,
  },
  props: {
    total: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      params: {
        page: 1,
        pageSize: 50,
      },
      timeInterval: 0,
    };
  },
  computed: {
    result() {
      // 兼容，当总数量大于实际数量时，重置offset
      const offset = this.params.pageSize * (this.params.page > 1 ? this.params.page - 1 : 0);

      return {
        offset: offset > this.total ? 0 : offset,
        limit: this.params.pageSize,
      };
    },
  },
  methods: {
    // 当总数量大于实际数量时
    // sizeChange和currentChange会同时触发，且sizeChange先触发。
    // 因此用timeInterval计算间隔，小于100时不触发
    onCurrentChange() {
      const now = Date.now();

      if (now - this.timeInterval > 100) {
        this.$emit('change', this.result);
      }

      this.timeInterval = Date.now();
    },
    onSizeChange() {
      this.$emit('change', this.result);
      this.timeInterval = Date.now();
    },
    update() {
      this.$emit('change', this.result);
    },
  },
};
</script>

<style>

</style>
